import React, { useEffect, useState } from "react";
import { CalendarDays, Trash2, Pencil, Edit2 } from "lucide-react";
import DashboardLayout from "../layout/index";
import patienticon from "../../assets/patienticon.svg";
import Calendericon from "../../assets/calender_icon.svg";
import doctor from "../../assets/doctor_icon.svg";
import calendervectoricon from "../../assets/calendervectoricon.svg";
import axios from "axios";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import Paymentmode from "./Paymentmode";
import PaymentModeModal from "./PaymentModeModal";
import { toast } from "react-toastify";
import EditVital from "./EditVital";
import { DatePicker, Modal } from "antd";
import EditMedicalHistory from "./EditMedicalHistory";

const PatientPreview = () => {
  const navigate = useNavigate();
  // const [notes, setNotes] = useState("");
  // const [followUp, setFollowUp] = useState("");
  const [patientDetails, setPatientDetails] = useState({});
  const [patientCode, setPatientCode] = useState("");
  const [vitalData, setVitalData] = useState();
  const [medicalData, setMedicalData] = useState();
  const [slotData, setSlotData] = useState();
  const [specializationdata, setSpecialization] = useState("");
  const [doctorFullNamedata, setDoctorFullName] = useState("");
  const [reportname, setReporntname] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [paymodalOpen, setPaymodalOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [paymenttype, setPaymenttype] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [labReports, setLabReports] = useState([]);
  const [prescriptionUrl, setPrescriptionUrl] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [appointmentRequestMode, setAppointmentRequestMode] = useState("");

  const location = useLocation();
  const { appointmentId, patientId } = location.state || {};

  console.log(appointmentId, patientId, "appointmentId");

  const handleSelectmode = async () => {
    if (paymenttype === "SKIP") {
      // await confirmAppointment("SKIP");
      navigate("/dashboard");
    } else if (paymenttype === "PAY") {
      setPaymodalOpen(false);
      setModalOpen(true);
    }
    localStorage.removeItem("vitaldata");
    localStorage.removeItem("medicaldata");
    localStorage.removeItem("doctorFullName");
    localStorage.removeItem("specialization");
  };
  const handlePay = async () => {
    // if (paymentMode === "CASH") {
    //   setPaymodalOpen(false);
    //   setModalOpen(true);
    //   // await confirmAppointment("CASH");
    // }
  };

  const confirmAppointment = async (mode) => {
    setIsLoggingIn(true);
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const userId = localStorage.getItem("userId");
 const clinicId = localStorage.getItem("clinicId");
    const payload = {
      patientId: slotData.patientId,
      userId: slotData.userId || doctorFullNamedata,
      clinicId: clinicId,
      locationId: "",
      whenAppointment: slotData.whenAppointment,
      fromTime: slotData.fromTime,
      toTime: slotData.toTime,
      consultationsReason: slotData.consultationsReason,
      status: "QUEUED",
      createdBy: userId,
      modifiedBy: userId,
      txnId: "",
      totalAmount: slotData.totalAmount || 400,
      payMode: mode,
      consultationType: "V",
      membershipCode: null,
      voucherCode: null,
      voucherTransId: null,
      cancelledReason: null,
      remarks: null,
      refundId: null,
      doctorStartTime: null,
      doctorEndTime: null,
      patientStartTime: null,
      patientEndTime: null,
    };

    try {
      const res = await axios.post(
        `${API_URL}queue/appointment-booking`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}`, tenantId: tenantId },
        }
      );

      if (res.status === 200) {
        toast.success("Appointment confirmed successfully!");
        localStorage.removeItem("patientcode");
        localStorage.removeItem("vitaldata");
        localStorage.removeItem("medicaldata");
        localStorage.removeItem("slotdata");
        localStorage.removeItem("doctorFullName");
        localStorage.removeItem("specialization");
        navigate("/QueueManagement");
      } else {
        toast.error("Failed to confirm appointment");
      }

      setModalOpen(false);
      setIsLoggingIn(false);
    } catch (error) {
      console.error("Appointment confirmation failed", error);
      toast.error("Something went wrong");
      setIsLoggingIn(false);
    }
  };

  const API_URL = process.env.REACT_APP_API_URL;
  useEffect(() => {
    const storedPatientCode = localStorage.getItem("patientcode");
    const vitalData = localStorage.getItem("vitaldata");
    const storedVital =
      vitalData && vitalData !== "undefined" ? JSON.parse(vitalData) : null;

    const medicalData = localStorage.getItem("medicaldata");
    console.log(medicalData, "medicalData");
    const storedMedical =
      medicalData && medicalData !== "undefined"
        ? JSON.parse(medicalData)
        : null;

    const slotData = localStorage.getItem("slotdata");
    const storedSlot =
      slotData && slotData !== "undefined" ? JSON.parse(slotData) : null;
    const doctorFullName = localStorage.getItem("doctorFullName");
    const specialization = localStorage.getItem("specialization");
    const appointmentRequestMode = localStorage.getItem(
      "appointmentRequestMode"
    );

    if (storedPatientCode) setPatientCode(storedPatientCode);
    setVitalData(storedVital);
    setMedicalData(storedMedical);
    setSlotData(storedSlot);
    setSpecialization(specialization);
    setDoctorFullName(doctorFullName);
    setAppointmentRequestMode(appointmentRequestMode);
  }, []);

  useEffect(() => {
    const fetchpatient = async () => {
      const code = localStorage.getItem("patientcode");
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      if (code) {
        try {
          const response = await axios.get(
            `${API_URL}patient/search?patientId=${code}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                tenantId: tenantId,
              },
            }
          );
          console.log(response.data, "zsxdcfvghbjcfvgbh");
          const firstPatient = response?.data.data[0];
          console.log(firstPatient, response, "dfghjk");
          setPatientDetails(firstPatient);
        } catch (error) {
          console.error("Error fetching slots:", error);
        }
      }
    };
    fetchpatient();
    handleSearch();
  }, [patientId]);

  const handleSearch = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const url = `${API_URL}patient/search?patientId=${patientId}`;

    try {
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      });

      const data = await res.json();

      if (Array.isArray(data?.data)) {
        setSearchResults(data.data[0]);
      } else {
        setSearchResults([]);
        toast.error("No patient found.");
      }
    } catch (error) {
      console.error("Search error:", error);
      toast.error("Something went wrong while searching.");
    }
  };

  useEffect(() => {
    if (!medicalData) return;

    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    // Fetch Prescription URL
    const fetchPrescription = async () => {
      try {
        const res = await axios.get(
          `${API_URL}patient-medical-history/file-url?fileName=${medicalData.documentUrl}`,
          { headers: { Authorization: `Bearer ${token}`, tenantId: tenantId } }
        );
        setPrescriptionUrl(res.data.signedUrl);
      } catch (err) {
        console.error("Error fetching prescription URL", err);
      }
    };

    // Fetch Lab Report URLs
    const fetchLabReports = async () => {
      try {
        const urls = await Promise.all(
          (medicalData.labReportUrls || []).map(async (fileName) => {
            const res = await axios.get(
              `${API_URL}patient-medical-history/file-url?fileName=${fileName}`,
              { headers: { Authorization: `Bearer ${token}`, tenantId: tenantId } }
            );
            return {
              name: fileName,
              signedUrl: res.data.signedUrl,
            };
          })
        );
        setLabReports(urls);
      } catch (err) {
        console.error("Error fetching lab reports", err);
      }
    };

    if (medicalData.documentUrl) fetchPrescription();
    if (medicalData.labReportUrls?.length) fetchLabReports();
  }, [medicalData]);

  const formattedDate = moment(slotData?.whenAppointment).format("DD-MM-YYYY");
  const dayOfWeek = moment(slotData?.whenAppointment).format("dddd");
  console.log(patientDetails, vitalData, medicalData, "ftyguhjkl");
  const redirectpage = async () => {
    localStorage.removeItem("patientcode");
    localStorage.removeItem("vitaldata");
    localStorage.removeItem("medicaldata");
    localStorage.removeItem("slotdata");
    localStorage.removeItem("doctorFullName");
    localStorage.removeItem("specialization");
    navigate("/QueueManagement");
  };
  console.log(slotData, "dxfghjfghjk");
  return (
    <DashboardLayout>
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_370px] gap-6  min-h-screen p-4 lg:p-8">
        {/* Left Section */}
        <div className="space-y-6">
          <h2 className="text-lg font-semibold text-blue-900 mb-0">
            Set Appointment
          </h2>
          <PatientDetailsCard
            patientDetails={patientDetails}
            slotData={slotData}
            searchResults={searchResults}
          />
          <Symptoms
            slotData={slotData}
            doctorFullNamedata={doctorFullNamedata}
            specializationdata={specializationdata}
          />

          <Vital vitalData={vitalData} patientId={patientId} />
          <MedicalHistory medicalData={medicalData}  patientId={patientId} />
        </div>

        {/* Right Sidebar */}
        <div className="space-y-6 sticky top-0 self-start">
          <div className="bg-[#F7FCFE] p-5 rounded-lg shadow-md text-sm text-blue-900">
            <div className="flex justify-between items-center mb-3">
              <h3 className="text-md font-semibold">Summary:</h3>
              {/* <p className="text-sm">
                Queue No: <span className="text-green-600 font-bold">050</span>
              </p> */}
            </div>

            {/* Doctor Info Card */}
            <div className="bg-white rounded-lg border p-4 mb-3 flex justify-between items-start">
              <div className="flex gap-4 items-start">
                <img
                  src={doctor} // replace with your actual icon
                  alt="Doctor"
                  className="w-8 h-8 mt-1"
                />
                <div>
                  <p className="text-[#00A67E] font-semibold mb-0">
                    {doctorFullNamedata}
                  </p>
                  <p className="text-xs text-gray-500">{specializationdata}</p>
                </div>
              </div>
            </div>
            <div>
              <p className="mb-1">
                Appointment Date And Time:{" "}
                <span className="text-[#00BD7F] font-medium">
                  {formattedDate}, {slotData?.fromTime}
                </span>
              </p>
              <p className="mb-1">
                Consultation Type:{" "}
                <span className="text-[#00BD7F] font-medium">
                  {slotData?.consultationType === "V"
                    ? "Video"
                    : slotData?.consultationType === "I"
                    ? "In Person"
                    : "—"}
                </span>
              </p>
              <p className="mb-1">
                Consultation Fee:{" "}
                <span className="text-[#00BD7F] font-medium">
                ₹ {slotData?.modifiedFeeAmount || slotData?.totalAmount}
                </span>
              </p>
              {appointmentRequestMode && (
                <p>
                  Appointment Request Mode:{" "}
                  <span className="text-[#00BD7F] font-medium">
                    {appointmentRequestMode}
                  </span>
                </p>
              )}

              {/* <p className="text-sm">
                  <span className="font-semibold text-[#1A1A1A]">
                    Appointment Date And Time:
                  </span>{" "}
                  <span className="text-[#00BD7F] font-medium">
                    {formattedDate}, {slotData?.fromTime}
                  </span>
                  <span className="mx-2 text-[#1A1A1A]">|</span>
                  <span className="font-semibold text-[#1A1A1A]">
                    Consultation Type:
                  </span>{" "}
                  <span className="text-[#00BD7F] font-medium">
                    {slotData?.consultationType === "V"
                      ? "Video"
                      : slotData?.consultationType === "I"
                      ? "In Person"
                      : "—"}
                  </span>
                </p> */}
            </div>

            {/* Appointment Date & Last Consultation */}
            {/* <div className="bg-white rounded-lg border p-4 mb-3 flex justify-between items-center">
              <div className="flex items-center gap-2">
                <img
                  src={calendervectoricon}
                  alt="Calendar"
                  className="w-5 h-5"
                />
                <div>
                  <p className="text-sm font-medium text-[#00A67E]">
                    {dayOfWeek} {formattedDate},{" "}
                  </p>
                </div>
              </div>
              <p className="text-xs text-gray-500">
                {" "}
                {slotData ? slotData.fromTime : ""}
              </p>
            </div> */}

            {/* Estimated Time */}
            {/* <div className="bg-white rounded-lg border p-4 mb-3 flex justify-between items-center">
              <div className="flex items-center gap-2">
                <img src={calendervectoricon} alt="Time" className="w-5 h-5" />
                <p className="text-sm text-gray-700">Estimated Waiting Time</p>
              </div>
              <p className="text-sm text-[#00A67E] font-medium">
                {slotData?.estimatedWaitTimeMins}
              </p>
            </div> */}

            {/* Button */}
            <button
              className="w-full bg-gradient-to-r from-[#004172] to-[#3cba84] text-white py-2 rounded-full hover:bg-[#152059] transition font-medium"
              onClick={() => setPaymodalOpen(true)}
            >
              Proceed to Payment
            </button>
          </div>
          {/* Prescription Viewer */}
          {prescriptionUrl && (
            <div className="bg-white p-5 rounded-lg shadow-md">
              <h3 className="text-md font-semibold text-blue-900 mb-3">
                View Prescription
              </h3>
              <div
                className="relative bg-[#f5faff] rounded-md border p-4 cursor-pointer hover:shadow"
                onClick={() =>
                  setPreviewFile({
                    name: "Prescription",
                    url: prescriptionUrl,
                    type: prescriptionUrl.includes(".pdf")
                      ? "application/pdf"
                      : "image/jpeg",
                  }) || setShowPreview(true)
                }
              >
                <p className="text-sm text-blue-800 font-medium underline">
                  Click to preview prescription
                </p>
              </div>
            </div>
          )}

          {/* Lab Reports Viewer */}
          {labReports.length > 0 && (
            <div className="bg-white p-5 rounded-lg shadow-md">
              <h3 className="text-md font-semibold text-blue-900 mb-3">
                View Lab Reports
              </h3>
              <div className="space-y-3">
                {labReports.map((report, index) => (
                  <div
                    key={index}
                    className="relative bg-[#f5faff] rounded-md border p-4 cursor-pointer hover:shadow"
                    onClick={() =>
                      setPreviewFile({
                        name: `Lab Report ${index + 1}`,
                        url: report.signedUrl,
                        type: report.signedUrl.includes(".pdf")
                          ? "application/pdf"
                          : "image/jpeg",
                      }) || setShowPreview(true)
                    }
                  >
                    <p className="text-sm text-blue-800 font-medium underline">
                      Click to preview Lab Report {index + 1}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      {showPreview && previewFile && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
          <div className="bg-white w-full max-w-md md:max-w-2xl lg:max-w-4xl max-h-[90vh] rounded-2xl overflow-auto shadow-2xl">
            <div className="flex items-center justify-between p-6 border-b">
              <h3 className="text-lg font-semibold text-gray-900">
                {previewFile.name}
              </h3>
              <button
                onClick={() => setShowPreview(false)}
                className="p-2 text-gray-600"
              >
                ✕
              </button>
            </div>
            <div className="p-6">
              {previewFile.type?.startsWith("image/") ? (
                <img
                  src={previewFile.url}
                  className="max-w-full h-auto rounded"
                />
              ) : previewFile.type === "application/pdf" ? (
                <iframe src={previewFile.url} className="w-full h-96 rounded" />
              ) : (
                <p className="text-center text-gray-500">
                  No preview available
                </p>
              )}
            </div>
          </div>
        </div>
      )}

      <Paymentmode
        isOpen={paymodalOpen}
        onClose={() => setPaymodalOpen(false)}
        onSelect={handleSelectmode}
        setPaymenttype={setPaymenttype}
        isLoggingIn={isLoggingIn}
        paymenttype={paymenttype}

      />

      <PaymentModeModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onPay={handlePay}
        setPaymentMode={setPaymentMode}
        isLoggingIn={isLoggingIn}
        paymentMode={paymentMode}
        paymentItem={appointmentId}
        paymenttype="Appointment"
      />
    </DashboardLayout>
  );
};

const PatientDetailsCard = ({ patientDetails, slotData, searchResults }) => {
  const formattedDate = moment(slotData?.whenAppointment).format("DD-MM-YYYY");
  return (
    <div className="bg-white rounded-md px-5 py-2 shadow border">
      {/* Header */}
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-base font-semibold text-[#222222]">
          Patient Details
        </h2>
      </div>

      {/* Patient Info */}
      <div className="flex justify-between items-start flex-wrap gap-4">
        <div className="flex items-start gap-4">
          <img src={patienticon} alt="Patient" className="w-[38px] h-[38px]" />
          <div className="flex flex-col">
            <div className="flex items-center gap-2 text-sm">
              <p className="text-[#00BD7F] font-medium text-base mb-0">
                {searchResults.salutation ? searchResults.salutation : ""}{" "}
                {searchResults.firstName} {searchResults.lastName}
              </p>

              <span className="text-[#00BD7F] border-x px-2">
                {searchResults.age}
              </span>
              <span className="text-[#00BD7F]">{searchResults.gender}</span>
            </div>
            <p className="text-sm font-normal text-[#1A1A1A] mt-1 mb-0">
              {searchResults.mobileNumber}
            </p>
            <p className="text-sm text-[#1A1A1A] mt-1">
              {searchResults.address
                ? `${searchResults.address}, ${searchResults.pinCode}`
                : ""}
            </p>
          </div>
        </div>

        {/* Buttons */}
        {/* <div className="flex gap-2 mt-2 sm:mt-0">
          <button className="bg-[#003c71] text-white px-4 py-1.5 text-sm font-medium rounded-full">
            View Past Prescription
          </button>
          <button className="border border-[#003c71] text-[#003c71] px-4 py-1.5 text-sm font-medium rounded-full">
            View Past Vitals
          </button>
        </div> */}
      </div>

      {/* Appointment Info */}
      {/* <div className="mt-7 mb-1 border border-[#00BD7F] rounded-md bg-[#E6FFF8] px-4 py-2 w-full flex justify-center items-center gap-2">
        <img src={Calendericon} alt="calendar" className="w-5 h-5" />
        <span className="text-sm">
          <span className="font-semibold text-[#1A1A1A]">
            Appointment Date And Time:
          </span>{" "}
          <span className="text-[#00BD7F] font-medium">
            {formattedDate}, {slotData?.fromTime}
          </span>
          <span className="mx-2 text-[#1A1A1A]">|</span>
          <span className="font-semibold text-[#1A1A1A]">
            Consultation Type:
          </span>{" "}
          <span className="text-[#00BD7F] font-medium">
            {slotData?.consultationType === "V"
              ? "Video"
              : slotData?.consultationType === "I"
              ? "In Person"
              : "—"}
          </span>
        </span>
      </div> */}
    </div>
  );
};

const Symptoms = ({ slotData, doctorFullNamedata, specializationdata }) => {
  return (
    <div className="">
      <h3 className="text-lg font-semibold text-blue-900 mb-2">Symptoms</h3>
      <textarea
        // placeholder="Enter symptoms..."
        // className="w-full border px-4 py-2 rounded resize-none text-sm mb-2"
        className="w-full border px-3 py-2 rounded text-sm  text-[#838383] font-medium "
        rows={2}
        value={slotData?.consultationsReason || ""}
        readOnly
      />
      {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="text-base font-medium text-[#004276] mb-2 block">
            Specialization
          </label>
          <input
            type="text"
            value={specializationdata || ""}
            readOnly
            placeholder="Enter specialization"
            className="w-full border px-3 py-2 rounded text-sm  text-[#838383] font-medium"
          />
        </div>

        <div>
          <label className="text-base font-medium text-[#004276] mb-2 block">
            Doctor Name
          </label>
          <input
            value={doctorFullNamedata || ""}
            readOnly
            type="text"
            placeholder="Enter specialization"
            className="w-full border px-3 py-2 rounded text-sm  text-[#838383] font-medium"
          />
        </div>
      </div> */}
    </div>
  );
};
const Vital = ({ vitalData: initialVitalData, patientId }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editVitals, setEditVitals] = useState();
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const API_BASE = process.env.REACT_APP_API_URL;
  // useEffect(() => {
  //   setEditVitals(initialVitalData || {});
  // }, [initialVitalData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditVitals((prev) => ({ ...prev, [name]: value }));
  };
  useEffect(() => {
    fetchVitals();
  }, []);
  const fetchVitals = async () => {
    try {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      const res = await axios.get(
        `${API_BASE}patient-vitals/by-patient?patientCode=${patientId}`,
        { headers: { Authorization: `Bearer ${token}`, tenantId: tenantId } }
      );
      setEditVitals(res.data.data[0] || []);
    } catch (err) {
      console.error("Failed to fetch vitals", err);
    } finally {
      // setLoadingData(false);
    }
  };
  const handleEdit = () => setIsEditing(true);
  const handleCancel = () => {
    setIsEditing(false);
    setEditVitals(initialVitalData || {});
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      // Use patientCode from localStorage or from initialVitalData
      const patientCode = initialVitalData?.id;
      const API_URL = process.env.REACT_APP_API_URL;
      const url = `${API_URL}patient-vitals/update/${patientCode}`;
      const payload = {
        patientCode: initialVitalData?.patientCode,
        temperature: Number(editVitals.temperature) || 0,
        respirationRate: Number(editVitals.respirationRate) || 0,
        bloodPressureSystolic: Number(editVitals.bloodPressureSystolic) || 0,
        bloodPressureDiastolic: Number(editVitals.bloodPressureDiastolic) || 0,
        pulse: Number(editVitals.pulse) || 0,
        heartRate: Number(editVitals.heartRate) || 0,
        heightFeet: Number(editVitals.heightFeet) || 0,
        heightInches: Number(editVitals.heightInches) || 0,
        heightCm: Number(editVitals.heightCm) || 0,
        weightInKg: Number(editVitals.weightInKg) || 0,
        bloodGlucose: editVitals.bloodGlucose || "",
        bmi: Number(editVitals.bmi) || 0,
        oxygenLevel: Number(editVitals.oxygenLevel) || 0,
      };
      await axios.put(url, payload, {
        headers: { Authorization: `Bearer ${token}`, tenantId: tenantId },
      });
      toast.success("Vitals updated successfully!");
      setIsEditing(false);
      // Optionally, trigger a refresh or update parent state
      window.location.reload();
    } catch (err) {
      toast.error("Failed to update vitals");
    } finally {
      setLoading(false);
    }
  };
  console.log(editVitals, "editVitals");
  if (!editVitals) return null; // Optional safety check

  //   const heightCmValue = editVitals.heightCm
  //   ? Number(editVitals.heightCm)
  //   : (Number(editVitals.heightFeet) * 12 + Number(editVitals.heightInches)) * 2.54 || 0;
  // const weightKg = Number(editVitals.weightInKg) || 0;

  // const computedBmi =
  //   heightCmValue > 0 && weightKg > 0
  //     ? (weightKg / (heightCmValue / 100) ** 2).toFixed(1)
  //     : "";

  // const bmiValue = editVitals.bmi || computedBmi;
  const OnCancelbtn = async () => {
    setOpenModal(false);
    fetchVitals();
  };
  return (
    <div className="">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-lg font-semibold text-blue-900">Vitals Details</h3>
        {!isEditing && (
          <button
            className="text-white text-sm  bg-[#004276] px-2 py-[2px] rounded-md"
            // onClick={handleEdit}
            onClick={() => setOpenModal(true)}
            type="button"
          >
            Edit
          </button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Height */}
        <div>
          <label className="text-sm text-blue-900 font-medium">Height</label>
          <div className="flex mt-2 w-full rounded overflow-hidden border bg-white pr-2">
            {/* {isEditing ? (
              <>
                <input
                  name="heightCm"
                  value={editVitals.heightCm || ""}
                  onChange={handleChange}
                  className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
                  placeholder="Height (cm)"
                  type="number"
                />
                <span className="text-sm text-blue-900 flex items-center">
                  cm
                </span>
              </>
            ) : ( */}
            <>
              <input
                value={
                  editVitals.heightFeet
                    ? `${editVitals.heightFeet || 0}' ${
                        editVitals.heightInches || 0
                      }\"`
                    : editVitals.heightCm
                    ? `${editVitals.heightCm || 0}`
                    : ""
                }
                readOnly
                className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
                placeholder="Height"
              />
              <span className="text-sm text-blue-900 flex items-center">
                {editVitals.heightFeet ? "ft/in" : "cm"}
              </span>
            </>
            {/* )} */}
          </div>
        </div>
        {/* Weight */}
        <div>
          <label className="text-sm text-blue-900 font-medium">Weight</label>
          <div className="flex mt-2 w-full rounded overflow-hidden border bg-white pr-2">
            {isEditing ? (
              <>
                <input
                  name="weightInKg"
                  value={editVitals.weightInKg || ""}
                  onChange={handleChange}
                  className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
                  placeholder="Weight (kg)"
                  type="number"
                />
                <span className="text-sm text-blue-900 flex items-center">
                  kg
                </span>
              </>
            ) : (
              <>
                <input
                  value={editVitals.weightInKg || ""}
                  readOnly
                  className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
                  placeholder="Weight"
                />
                <span className="text-sm text-blue-900 flex items-center">
                  kg
                </span>
              </>
            )}
          </div>
        </div>
        {/* Temperature */}
        <div>
          <label className="text-sm text-blue-900 font-medium">
            Temperature
          </label>
          <div className="flex mt-2 w-full rounded overflow-hidden border bg-white pr-2">
            {isEditing ? (
              <>
                <input
                  name="temperature"
                  value={editVitals.temperature || ""}
                  onChange={handleChange}
                  className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
                  placeholder="Temperature (°F)"
                  type="number"
                />
                <span className="text-sm text-blue-900 flex items-center">
                  °F
                </span>
              </>
            ) : (
              <>
                <input
                  value={editVitals.temperature || ""}
                  readOnly
                  className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
                  placeholder="Temperature"
                />
                <span className="text-sm text-blue-900 flex items-center">
                  °F
                </span>
              </>
            )}
          </div>
        </div>
        {/* Respiration Rate */}
        <div>
          <label className="text-sm text-blue-900 font-medium">
            Respiration Rate
          </label>
          <div className="flex mt-2 w-full rounded overflow-hidden border bg-white pr-3">
            {isEditing ? (
              <>
                <input
                  name="respirationRate"
                  value={editVitals.respirationRate || ""}
                  onChange={handleChange}
                  className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
                  placeholder="Respiration Rate (bpm)"
                  type="number"
                />
                <span className="text-sm text-blue-900 flex items-center">
                  bpm
                </span>
              </>
            ) : (
              <>
                <input
                  value={editVitals.respirationRate || ""}
                  readOnly
                  className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
                  placeholder="Respiration Rate"
                />
                <span className="text-sm text-blue-900 flex items-center">
                  bpm
                </span>
              </>
            )}
          </div>
        </div>
        {/* Blood Pressure */}
        <div>
          <label className="text-sm text-blue-900 font-medium">
            Blood Pressure
          </label>
          <div className="flex mt-2 w-full rounded overflow-hidden border bg-white pr-3 gap-1">
            {isEditing ? (
              <>
                <input
                  name="bloodPressureSystolic"
                  value={editVitals.bloodPressureSystolic || ""}
                  onChange={handleChange}
                  className="px-2 py-2 text-sm text-[#838383] bg-white focus:outline-none w-12"
                  placeholder="Sys"
                  type="number"
                />
                <span className="mx-1">/</span>
                <input
                  name="bloodPressureDiastolic"
                  value={editVitals.bloodPressureDiastolic || ""}
                  onChange={handleChange}
                  className="px-2 py-2 text-sm text-[#838383] bg-white focus:outline-none w-12"
                  placeholder="Dia"
                  type="number"
                />
                <span className="text-sm text-blue-900 flex items-center">
                  mmHg
                </span>
              </>
            ) : (
              <>
                <input
                  value={`${editVitals.bloodPressureSystolic || ""}/${
                    editVitals.bloodPressureDiastolic || ""
                  }`}
                  readOnly
                  className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
                  placeholder="Blood Pressure"
                />
                <span className="text-sm text-blue-900 flex items-center">
                  mmHg
                </span>
              </>
            )}
          </div>
        </div>
        {/* Oxygen Level */}
        <div>
          <label className="text-sm text-blue-900 font-medium">
            Oxygen Level
          </label>
          <div className="flex mt-2 w-full rounded overflow-hidden border bg-white pr-3">
            {isEditing ? (
              <>
                <input
                  name="oxygenLevel"
                  value={editVitals.oxygenLevel || ""}
                  onChange={handleChange}
                  className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
                  placeholder="Oxygen Level (%)"
                  type="number"
                />
                <span className="text-sm text-blue-900 flex items-center">
                  %
                </span>
              </>
            ) : (
              <>
                <input
                  value={editVitals.oxygenLevel || ""}
                  readOnly
                  className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
                  placeholder="Oxygen Level"
                />
                <span className="text-sm text-blue-900 flex items-center">
                  %
                </span>
              </>
            )}
          </div>
        </div>
        {/* Heart Rate */}
        <div>
          <label className="text-sm text-blue-900 font-medium">
            Heart Rate
          </label>
          <div className="flex mt-2 w-full rounded overflow-hidden border bg-white pr-4">
            {isEditing ? (
              <>
                <input
                  name="heartRate"
                  value={editVitals.heartRate || ""}
                  onChange={handleChange}
                  className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
                  placeholder="Heart Rate (Beat/min)"
                  type="number"
                />
                <span className="text-sm text-blue-900 flex items-center">
                  Beat/min
                </span>
              </>
            ) : (
              <>
                <input
                  value={editVitals.heartRate || ""}
                  readOnly
                  className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
                  placeholder="Heart Rate"
                />
                <span className="text-sm text-blue-900 flex items-center">
                  Beat/min
                </span>
              </>
            )}
          </div>
        </div>
        {/* Blood Glucose */}
        <div>
          <label className="text-sm text-blue-900 font-medium">
            Blood Glucose
          </label>
          <div className="flex mt-2 w-full rounded overflow-hidden border bg-white pr-4">
            {isEditing ? (
              <>
                <input
                  name="bloodGlucose"
                  value={editVitals.bloodGlucose || ""}
                  onChange={handleChange}
                  className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
                  placeholder="Blood Glucose (mg/dL)"
                  type="text"
                />
                <span className="text-sm text-blue-900 flex items-center">
                  mg/dL
                </span>
              </>
            ) : (
              <>
                <input
                  value={editVitals.bloodGlucose || ""}
                  readOnly
                  className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
                  placeholder="Blood Glucose"
                />
                <span className="text-sm text-blue-900 flex items-center">
                  mg/dL
                </span>
              </>
            )}
          </div>
        </div>
        {/* Pulse */}
        {/* <div>
          <label className="text-sm text-blue-900 font-medium">Pulse</label>
          <div className="flex mt-2 w-full rounded overflow-hidden border bg-white pr-4">
            {isEditing ? (
              <>
                <input
                  name="pulse"
                  value={editVitals.pulse || ""}
                  onChange={handleChange}
                  className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
                  placeholder="Pulse"
                  type="number"
                />
                <span className="text-sm text-blue-900 flex items-center">
                  bpm
                </span>
              </>
            ) : (
              <>
                <input
                  value={editVitals.pulse || ""}
                  readOnly
                  className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
                  placeholder="Pulse"
                />
                <span className="text-sm text-blue-900 flex items-center">
                  bpm
                </span>
              </>
            )}
          </div>
        </div> */}
        {/* BMI */}
        <div>
          <label className="text-sm text-blue-900 font-medium">BMI</label>
          <div className="flex mt-2 w-full rounded overflow-hidden border bg-white pr-4">
            <input
              value={editVitals.bmi || ""}
              readOnly
              className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
              placeholder="BMI"
            />
            {/* {isEditing ? (
              <>
                <input
                  name="bmi"
                  value={bmiValue || editVitals.bmi || ""}
                  onChange={handleChange}
                  className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
                  placeholder="BMI"
                  type="number"
                />
              </>
            ) : (
              <>
                <input
                  value={ bmiValue || editVitals.bmi || ""}
                  readOnly
                  className="flex-1 px-4 py-2 text-sm text-[#838383] bg-white focus:outline-none w-20"
                  placeholder="BMI"
                />
              </>
            )} */}
          </div>
        </div>
      </div>
      {isEditing && (
        <div className="flex gap-2 mt-4">
          <button
            className=" bg-gradient-to-r from-[#004172] to-[#3cba84] text-white px-4 py-2 rounded disabled:opacity-50"
            // onClick={handleSave}
            //  onClick={() => setOpenModal(true)}
            // disabled={loading}
            type="button"
          >
            {loading ? "Saving..." : "Save"}
          </button>
          <button
            className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300"
            onClick={handleCancel}
            type="button"
          >
            Cancel
          </button>
        </div>
      )}

      {openModal && (
        <Modal
          title={
            <div
              style={{
                backgroundColor: "#e6f7ff",
                padding: "12px 24px",
                margin: "-24px -24px 0 -24px",
              }}
            >
              Edit Vital
            </div>
          }
          open={openModal}
          onCancel={() => setOpenModal(false)}
          footer={null}
          width="75%"
        >
          <EditVital
            editVitals={editVitals}
            onCancel={OnCancelbtn}
            smartvital={true}
            patientId={patientId}
          />
        </Modal>
      )}
    </div>
  );
};

const MedicalHistory = ({ medicalData: initialMedicalData,patientId }) => {
  const API_BASE = process.env.REACT_APP_API_URL;
  const [isEditing, setIsEditing] = useState(false);
  const [editMedical, setEditMedical] = useState();
  const [loading, setLoading] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  useEffect(() => {
    setEditMedical(initialMedicalData || {});
  }, [initialMedicalData]);

  useEffect(() => {
    if (initialMedicalData?.patientCode) {
      fetchMedicaldata();
    }
  }, []);
 

  const fetchMedicaldata = async () => {
    try {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      const res = await axios.get(
        `${API_BASE}patient-medical-history/by-patient?patientCode=${initialMedicalData.patientCode}`,
        { headers: { Authorization: `Bearer ${token}`, tenantId: tenantId } }
      );
      console.log(res.data.data,"resuygbkjhk")
      const medicalData = res.data.data[res.data.data.length - 1]  || {};
      setEditMedical(medicalData);
      console.log(medicalData,"medicalDatamedicalData")
      // Also update the localStorage with fresh data
      if (medicalData && Object.keys(medicalData).length > 0) {
        localStorage.setItem("medicaldata", JSON.stringify(medicalData));
      }
    } catch (err) {
      console.error("Failed to fetch medical data", err);
    }
  };

  const OnCancelbtn2 = async () => {
    setOpenModal2(false);
    // Refresh medical data after modal closes
    if (initialMedicalData?.patientCode) {
      fetchMedicaldata();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditMedical((prev) => ({ ...prev, [name]: value }));
  };

  const handleEdit = () => setIsEditing(true);
  const handleCancel = () => {
    setIsEditing(false);
    setEditMedical(initialMedicalData || {});
  };

  const handleSave = async () => {
    setLoading(true);
    try {
        const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      const medicalId = initialMedicalData?.id;
      const API_URL = process.env.REACT_APP_API_URL;
      const url = `${API_URL}patient-medical-history/update/${medicalId}`;
      const payload = {
        patientCode: initialMedicalData?.patientCode,
        allergyHistory: editMedical.allergyHistory || "",
        medicalHistory: editMedical.medicalHistory || "",
        surgicalHistory: editMedical.surgicalHistory || "",
        familyHistory: editMedical.familyHistory || "",
        socialHistory: editMedical.socialHistory || "",
        medication: editMedical.medication || "",
      };
      await axios.put(url, payload, {
        headers: { Authorization: `Bearer ${token}`, tenantId: tenantId },
      });
      toast.success("Medical history updated successfully!");
      setIsEditing(false);
      window.location.reload();
    } catch (err) {
      toast.error("Failed to update medical history");
    } finally {
      setLoading(false);
    }
  };

  if (!editMedical) return null;
  return (
    <div className="">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-lg font-semibold text-blue-900">Medical History</h3>
        {!isEditing && (
          <button
            className="text-white text-sm  bg-[#004276] px-2 py-[2px] rounded-md"
            // onClick={handleEdit}
            onClick={() => setOpenModal2(true)}
            type="button"
          >
            Edit
          </button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="text-sm text-blue-900">Any Allergy History?</label>
          {isEditing ? (
            <textarea
              name="allergyHistory"
              className="w-full border px-3 py-2 rounded mt-2 text-sm text-[#838383] font-medium"
              rows={2}
              value={editMedical.allergyHistory || ""}
              onChange={handleChange}
            />
          ) : (
            <textarea
              value={editMedical?.allergyHistory || ""}
              readOnly
              className="w-full border px-3 py-2 rounded mt-2 text-sm text-[#838383] font-medium"
              rows={2}
            />
          )}
        </div>
        <div>
          <label className="text-sm text-blue-900">Any Medical History?</label>
          {isEditing ? (
            <textarea
              name="medicalHistory"
              value={editMedical.medicalHistory || ""}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded mt-2 text-sm text-[#838383] font-medium"
              rows={2}
            />
          ) : (
            <textarea
              value={editMedical?.medicalHistory || ""}
              readOnly
              className="w-full border px-3 py-2 rounded mt-2 text-sm text-[#838383] font-medium"
              rows={2}
            />
          )}
        </div>
        <div>
          <label className="text-sm text-blue-900">Any Surgical History?</label>
          {isEditing ? (
            <textarea
              name="surgicalHistory"
              value={editMedical.surgicalHistory || ""}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded mt-2 text-sm text-[#838383] font-medium"
              rows={2}
            />
          ) : (
            <textarea
              value={editMedical?.surgicalHistory || ""}
              readOnly
              className="w-full border px-3 py-2 rounded mt-2 text-sm text-[#838383] font-medium"
              rows={2}
            />
          )}
        </div>
        <div>
          <label className="text-sm text-blue-900">Any Family History?</label>
          {isEditing ? (
            <textarea
              name="familyHistory"
              value={editMedical.familyHistory || ""}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded mt-2 text-sm text-[#838383] font-medium"
              rows={2}
            />
          ) : (
            <textarea
              value={editMedical?.familyHistory || ""}
              readOnly
              className="w-full border px-3 py-2 rounded mt-2 text-sm text-[#838383] font-medium"
              rows={2}
            />
          )}
        </div>
        <div>
          <label className="text-sm text-blue-900">Any Social History?</label>
          {isEditing ? (
            <textarea
              name="socialHistory"
              value={editMedical.socialHistory || ""}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded mt-2 text-sm text-[#838383] font-medium"
              rows={2}
            />
          ) : (
            <textarea
              value={editMedical?.socialHistory || ""}
              readOnly
              className="w-full border px-3 py-2 rounded mt-2 text-sm text-[#838383] font-medium"
              rows={2}
            />
          )}
        </div>
        <div>
          <label className="text-sm text-blue-900">Any Medication?</label>
          {isEditing ? (
            <textarea
              name="medication"
              value={editMedical.medication || ""}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded mt-2 text-sm text-[#838383] font-medium"
              rows={2}
            />
          ) : (
            <textarea
              value={editMedical?.medication || ""}
              readOnly
              className="w-full border px-3 py-2 rounded mt-2 text-sm text-[#838383] font-medium"
              rows={2}
            />
          )}
        </div>
      </div>
      {isEditing && (
        <div className="flex gap-2 mt-4">
          <button
            className=" bg-gradient-to-r from-[#004172] to-[#3cba84] text-white px-4 py-2 rounded disabled:opacity-50"
            onClick={handleSave}
            disabled={loading}
            type="button"
          >
            {loading ? "Saving..." : "Save"}
          </button>
          <button
            className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300"
            onClick={handleCancel}
            type="button"
          >
            Cancel
          </button>
        </div>
      )}

      {openModal2 && (
        <Modal
          title="Add Medical History"
          open={openModal2}
          onCancel={() => setOpenModal2(false)}
          footer={null}
          width="75%"
        >
          <EditMedicalHistory
            editMedical={editMedical}
            onCancel={OnCancelbtn2}
            patientId={patientId}
          />
        </Modal>
      )}
    </div>
  );
};

export default PatientPreview;
